import { PREMISES_SET_SUBSCRIBE, PREMISES_SET_DASHBOARD_DISPLAY } from '../premises';

function result(state, action) {
    if (state.id !== action.id) {
        return state;
    }
    switch (action.type) {
        case PREMISES_SET_DASHBOARD_DISPLAY:
            return Object.assign({}, state, {dashboard_display: action.dashboard_display});
        case PREMISES_SET_SUBSCRIBE:
            return Object.assign({}, state, {subscribed: action.subscribed});
        default:
            return state;
    }
}

function results(state = [], action) {
    switch (action.type) {
        case PREMISES_SET_DASHBOARD_DISPLAY:
        case PREMISES_SET_SUBSCRIBE:
            return state.map(r => result(r, action));
        default:
            return state;
    }
}

export function premises(state, action) {
    return Object.assign({}, state,
        {results: results(state.results, action)}
    );
}
